import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import {
  Accordion,
  Button,
  Dropdown,
  Form,
  Grid,
  Icon,
  Input,
} from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
interface Props {
  dropdown: {
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  };
  setDropDown: any;
  notificationList: {
    key: string;
    value: string;
    elem: string;
    mode: number;
  }[];
  setNotificationList: any;
  handleAddItem: () => void;
  handleDropdownList: (e: any, data: any) => void;
}
function Notification({
  dropdown,
  notificationList,
  handleAddItem,
  handleDropdownList,
  setNotificationList,
}: Props) {
  const { CommunicationSettingStore } = useStore();
  const [activeIndex, setActiveIndex] = useState(0);
  const handleClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };
  const handleModeChange = (masterId: string, changeValue: string) => {
    const updatedNotificationList = notificationList.map((item: any) => {
      if (item === masterId) {
        item = item?.split('/')?.slice(0, 3)?.join('/');
        if (
          [
            'Contains',
            'Not Contains',
            'Beginning With',
            'Ending With',
          ].includes(changeValue)
        ) {
          return (item += `/${changeValue}`);
        } else if (
          [
            'Equal To',
            'Not Equal To',
            'Greater Than',
            'Less Than',
            'Greater Than or Equal To',
            'Less Than or Equal To',
          ].includes(changeValue)
        ) {
          return (item += `/${changeValue}`);
        } else {
          return item;
        }
      } else {
        return item;
      }
    });
    setNotificationList(updatedNotificationList);
  };
  const handleInputChange = (element: any, value: any) => {
    const updatedList = notificationList.map((item: any) => {
      if (item === element) {
        item = item?.split('/')?.slice(0, 4)?.join('/');
        if (element.split('/')[4] && value) {
          const lastSlashIndex = element.lastIndexOf('/');
          if (lastSlashIndex !== -1) {
            const updatedOutput = element.substring(0, lastSlashIndex);
            return updatedOutput + '/' + value;
          }
        } else if (value === '') {
          item = item?.split('/')?.slice(0, 4)?.join('/');
        } else {
          return element + '/' + value;
        }
      }
      return item;
    });
    // Assuming you want to update the existing state with the updated list
    setNotificationList(updatedList);
  };
  const deleteNotification = (ids: string) => {
    const updatedArray = notificationList.filter((item: any) => item !== ids);
    CommunicationSettingStore.notification(ids?.split('/')[0], {}, 'deleteApi');
    setNotificationList(updatedArray);
  };
  return (
    <div style={{ width: '95%', margin: 'auto' }}>
      <Accordion styled fluid>
        <Accordion.Title
          style={{ backgroundColor: 'white' }}
          active={activeIndex === 1}
          index={1}
          onClick={(e: any, Props: any) => handleClick(e, Props)}
        >
          <Icon name="dropdown" />
          Notification
        </Accordion.Title>
        <Accordion.Content
          style={{ backgroundColor: 'white' }}
          active={activeIndex === 1}
        >
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Dropdown
                  placeholder="--Select--"
                  value={dropdown.value}
                  fluid
                  selection
                  options={dropdown.list}
                  onChange={(e: any, data: any) => handleDropdownList(e, data)}
                />
              </Grid.Column>
              <Grid.Column>
                <Button
                  style={{ borderRadius: '30px' }}
                  positive
                  size="mini"
                  icon="plus"
                  onClick={handleAddItem}
                  disabled={!dropdown.value}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {notificationList?.map((element: any) => {
            return (
              <Grid>
                <Grid.Row columns={4}>
                  <Grid.Column>
                    <Form.Field
                      id="Type"
                      control={Input}
                      placeholder="Validation/Path"
                      value={element?.split('/')[1]}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Dropdown
                      placeholder="--Select Conditions--"
                      fluid
                      selection
                      options={NotificationConditions}
                      clearable
                      name="conditons"
                      value={element?.split('/')[3]}
                      onChange={(e, data) =>
                        handleModeChange(element, data.value as string)
                      }
                    />
                  </Grid.Column>
                  <Grid.Column>
                    {[
                      'Contains',
                      'Not Contains',
                      'Beginning With',
                      'Ending With',
                    ].includes(element?.split('/')[3]) && (
                      <Form.Field
                        placeholder="Enter a text"
                        fluid
                        control={Input}
                        name="conditons"
                        value={element?.split('/')[4]}
                        onChange={(e: any, data: any) =>
                          handleInputChange(element, data.value)
                        }
                      />
                    )}
                    {[
                      'Equal To',
                      'Not Equal To',
                      'Greater Than',
                      'Less Than',
                      'Greater Than or Equal To',
                      'Less Than or Equal To',
                    ].includes(element?.split('/')[3]) && (
                      <Form.Field
                        placeholder="Enter a number"
                        fluid
                        control={Input}
                        name="conditons"
                        value={element?.split('/')[4]}
                        onChange={(e: any, data: any) =>
                          handleInputChange(element, data.value)
                        }
                      />
                    )}
                  </Grid.Column>
                  <Grid.Column>
                    {
                      <Icon
                        name="trash"
                        color="red"
                        className="trashIcon"
                        onClick={() => deleteNotification(element)}
                      />
                    }
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            );
          })}
        </Accordion.Content>
      </Accordion>
    </div>
  );
}
export default observer(Notification);

export const NotificationConditions = [
  { key: 1, text: 'Equal To', value: 'Equal To' },
  { key: 2, text: 'Not Equal To', value: 'Not Equal To' },
  { key: 3, text: 'Greater Than', value: 'Greater Than' },
  { key: 4, text: 'Less Than', value: 'Less Than' },
  {
    key: 5,
    text: 'Greater Than or Equal To',
    value: 'Greater Than or Equal To',
  },
  { key: 6, text: 'Less Than or Equal To', value: 'Less Than or Equal To' },

  { key: 7, text: 'Contains', value: 'Contains' },
  { key: 8, text: 'Not Contains', value: 'Not Contains' },
  { key: 9, text: 'Beginning With', value: 'Beginning With' },
  { key: 10, text: 'Ending With', value: 'Ending With' },
];
